module.exports = __webpack_public_path__ + "media/images/athletes/539-53b238d6f9a55531cde16134564fe928.png";